import React from 'react'

import i18n from 'i18n'

import { OmTabs } from '@owma/kit'

import classNames from 'classnames'
import { i18Key } from 'utils'
import { toDavPath, isSameDavUrl } from 'libs/dav/davPath'
// import { notImplemented } from 'utils/ui'

import { UIGroup, ViewGroup } from 'utils/ui/propsUI'

import settings from '../index'

import styles from './style.module.scss'

import FolderSelector from 'pages/todo/components/TodoEditor/FolderSelector'
import TimezonePicker from 'pages/calendar/components/TimezonePicker'
import WorkHoursPanel from './WorkHoursPanel'
import { SettingsInterface } from '../def'

// CalendarService 모듈 동적 로딩
// CalendarService 내에서 settings 모듈을 사용하기 때문에 나중에 로딩되도록 수정.
// 이부분 import 타이밍은 초기 접속시에 loading 되므로 실제 Setting UI 가 나타날때는 문제가 되지 않음.
let calendarService: any = null
import('pages/calendar/modules/CalendarService').then((module) => {
  calendarService = module
})

interface CalendarSettingsProps {
  innerRef?: React.MutableRefObject<SettingsInterface | null>
  owner: any
  isMobile?: boolean
  parentLabel?: any
  idx?: string | number
}

interface CalendarSettingsState {}

class SettingItem
  extends React.Component<CalendarSettingsProps, CalendarSettingsState>
  implements SettingsInterface
{
  state: CalendarSettingsState = {}

  uiGroupMap: Record<string, any> = {}

  vGroupMap: Record<string, any> = {}

  curValueMap: Record<string, any> = {}

  isUICreated: boolean = false

  componentDidMount(): void {
    const { innerRef } = this.props
    if (innerRef != null) {
      innerRef.current = this
    }

    this.applySettings()
  }

  // componentDidUpdate(prevProps) {
  //   const { mailbox, selectedEmail } = this.props
  // }

  componentWillUnmount(): void {}

  createUIGroup = (): void => {
    if (this.isUICreated === true) {
      return
    }

    this.isUICreated = true

    this.createGeneralUIGroup()
    this.createViewUIGroup()
    this.createTimezoneUIGroup()
    this.createAdvancedUIGroup()
  }

  createGeneralUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        // titleKey: i18Key('settings.subtitle.Stationary'),
        // desc: null,
      }),
    ]

    const uiProps: any = {
      defaultDuration: {
        labelKey: i18Key('settings.fields.calDuration'),
        readOnly: false,
        format: 'om-select',
        default: 30,
        values: [
          { value: 15, labelKey: i18Key('settings.values.time.min15') },
          { value: 20, labelKey: i18Key('settings.values.time.min20') },
          { value: 30, labelKey: i18Key('settings.values.time.min30') },
          { value: 45, labelKey: i18Key('settings.values.time.min45') },
          { value: 60, labelKey: i18Key('settings.values.time.min60') },
          { value: 90, labelKey: i18Key('settings.values.time.min90') },
          { value: 120, labelKey: i18Key('settings.values.time.min120') },
        ],
        vGroup: vGroups[0],
      },
      defaultReminderTime: {
        labelKey: i18Key('settings.fields.calReminderTime'),
        readOnly: false,
        format: 'om-select',
        default: -900,
        values: [
          { value: 1, labelKey: i18Key('settings.values.preTime.off') },
          { value: 0, labelKey: i18Key('settings.values.preTime.atTime') },
          { value: -300, labelKey: i18Key('settings.values.preTime.min5') },
          { value: -600, labelKey: i18Key('settings.values.preTime.min10') },
          { value: -900, labelKey: i18Key('settings.values.preTime.min15') },
          { value: -1800, labelKey: i18Key('settings.values.preTime.min30') },
          { value: -3600, labelKey: i18Key('settings.values.preTime.hour1') },
          { value: -7200, labelKey: i18Key('settings.values.preTime.hour2') },
          { value: -43200, labelKey: i18Key('settings.values.preTime.hour12') },
          { value: -86400, labelKey: i18Key('settings.values.preTime.day1') },
          { value: -172800, labelKey: i18Key('settings.values.preTime.day2') },
          { value: -604800, labelKey: i18Key('settings.values.preTime.week1') },
        ],
        vGroup: vGroups[0],
      },
      defaultReminderTimeForAll: {
        labelKey: i18Key('settings.fields.calReminderTimeForAll'),
        readOnly: false,
        format: 'om-select',
        default: -25200,
        values: [
          { value: 1, labelKey: i18Key('settings.values.timeForAll.off') },
          { value: -54000, labelKey: i18Key('settings.values.timeForAll.day_9') },
          { value: -25200, labelKey: i18Key('settings.values.timeForAll.day_5') },
          { value: -572400, labelKey: i18Key('settings.values.timeForAll.week_1') },
        ],
        vGroup: vGroups[0],
      },
    }

    this.vGroupMap.general = vGroups

    this.uiGroupMap.general = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createViewUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: null,
        descKey: null,
      }),
    ]

    const uiProps: any = {
      firstdayOfWeek: {
        labelKey: i18Key('settings.fields.firstdayOfWeek'),
        readOnly: false,
        format: 'om-select',
        default: 7,
        values: [
          { value: 7, labelKey: i18Key('settings.values.week.default') },
          { value: 6, labelKey: i18Key('settings.values.week.saturday') },
          { value: 0, labelKey: i18Key('settings.values.week.sunday') },
          { value: 1, labelKey: i18Key('settings.values.week.monday') },
        ],
        vGroup: vGroups[0],
      },
      hideDeclinedMeeting: {
        labelKey: i18Key('settings.fields.hideDeclinedMeeting'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
      hideCanceledMeeting: {
        labelKey: i18Key('settings.fields.hideCanceledMeeting'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
      showWeekNumber: {
        labelKey: i18Key('settings.fields.showWeekNumber'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
      firstWeekNumber: {
        labelKey: i18Key('settings.fields.firstWeekNumber'),
        readOnly: false,
        use: (info: any) => {
          const { showWeekNumber } = info.parent
          const value = showWeekNumber.wrapper.getValue()
          if (value === true) {
            return true
          }
          return false
        },
        format: 'om-select',
        default: 0,
        values: [
          { value: 0, labelKey: i18Key('settings.values.fwNumber.first') },
          { value: 1, labelKey: i18Key('settings.values.fwNumber.first4') },
          { value: 2, labelKey: i18Key('settings.values.fwNumber.firstFull') },
        ],
        vGroup: vGroups[0],
      },
    }

    this.vGroupMap.view = vGroups

    this.uiGroupMap.view = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  getSecondaryTimezoneDisabled = (): boolean => {
    const { owner } = this.props
    const { calendar: defaultCalendar } = owner.defaultValues
    const { calendar: newCalendar } = owner.newValues
    const { secondaryTimezone } =
      newCalendar && Object.keys(newCalendar).length > 0 ? newCalendar : defaultCalendar
    return secondaryTimezone == null
  }

  createTimezoneUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: i18Key('settings.fields.primaryTimezone'),
        descKey: null,
      }),
      new ViewGroup({
        titleKey: i18Key('settings.fields.secondaryTimezone'),
        descKey: null,
      }),
    ]

    const getCustomTimezonePicker = (isPrimary: boolean): any => {
      const clone = settings.getAll()
      const { calendar } = clone
      const { secondaryTimezone } = calendar
      let tzId: string | null = null
      if (isPrimary) {
        tzId = Intl.DateTimeFormat().resolvedOptions().timeZone
      } else {
        tzId = secondaryTimezone
      }

      return {
        useValue: true,
        onGetValue: (_info: any, _wrapper: any) => {},
        onSetValue: (_value: any, _info: any, _wrapper: any) => {},
        getElement: (info: any, wrapper: any) => {
          const { reactObj } = wrapper
          const { owner } = reactObj.props

          return (
            <TimezonePicker
              tzId={tzId}
              focusDate={new Date()}
              onTzChange={(aTzId: string | null) => {
                if (!isPrimary) {
                  /* i18next-extract-disable-next-line */
                  const label = aTzId ? i18n.t('timezone.' + aTzId) : null
                  tzId = aTzId
                  wrapper.setValue(aTzId)
                  info.parent.secondaryTimezoneLabel.wrapper.setValue(label)
                  if (aTzId == null) {
                    info.parent.showSecondaryTimezone.wrapper.setValue(false)
                  }
                  const orgValues = owner.newValues.calendar || owner.defaultValues.calendar
                  let forceOn = orgValues.secondaryTimezone == null && aTzId != null
                  const newValues = {
                    ...orgValues,
                    secondaryTimezone: aTzId,
                    secondaryTimezoneLabel: label,
                  }
                  if (forceOn) {
                    newValues.showSecondaryTimezone = true
                    info.parent.showSecondaryTimezone.wrapper.setValue(true)
                  }
                  if (aTzId == null) {
                    newValues.showSecondaryTimezone = false
                  }
                  owner.onChangeValue('calendar', newValues)

                  info.parent.secondaryTimezoneLabel.wrapper.inputAttrs.disabled =
                    info.parent.showSecondaryTimezone.wrapper.inputAttrs.disabled =
                      aTzId == null ? true : false
                }
              }}
              forSettings={true}
              disabled={isPrimary}
            />
          )
        },
      }
    }

    const uiProps: any = {
      primaryTimezone: {
        labelKey: i18Key('settings.fields.timezone'),
        readOnly: false,
        format: 'custom',
        default: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...getCustomTimezonePicker(true),
        vGroup: vGroups[0],
      },
      // primaryTimezoneLabel: {
      //   labelKey: i18Key('settings.fields.label'),
      //   readOnly: false,
      //   format: 'om-input',
      //   options: {
      //     placeholder: i18n.t('timezone.' + Intl.DateTimeFormat().resolvedOptions().timeZone),
      //   },
      //   default: i18n.t('timezone.' + Intl.DateTimeFormat().resolvedOptions().timeZone),
      //   vGroup: vGroups[0],
      // },
      secondaryTimezone: {
        labelKey: i18Key('settings.fields.timezone'),
        readOnly: false,
        format: 'custom',
        default: i18n.t('settings.accountTabs.none'),
        ...getCustomTimezonePicker(false),
        vGroup: vGroups[1],
      },
      secondaryTimezoneLabel: {
        labelKey: i18Key('settings.fields.label'),
        readOnly: false,
        options: {
          placeholder: i18n.t('settings.accountTabs.none'),
          id: 'secondaryTimezoneInput',
          disabled: this.getSecondaryTimezoneDisabled(),
        },
        format: 'om-input',
        default: i18n.t('settings.accountTabs.none'),
        vGroup: vGroups[1],
      },
      showSecondaryTimezone: {
        labelKey: i18Key('settings.fields.showInCalendar'),
        readOnly: false,
        format: 'om-switch',
        default: false,
        attrs: { className: classNames('halfWidth') },
        options: {
          disabled: this.getSecondaryTimezoneDisabled(),
          id: 'secondaryTimezoneSwitch',
        },
        vGroup: vGroups[1],
      },
    }

    this.vGroupMap.timezone = vGroups

    this.uiGroupMap.timezone = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createAdvancedUIGroup = (): void => {
    const clone = settings.getAll()

    const vGroups = [
      new ViewGroup({
        titleKey: null,
        descKey: null,
      }),
      new ViewGroup({
        titleKey: i18Key('settings.subtitle.sharedCalendar'),
        descKey: null,
      }),
    ]

    const getCustomFolder = (): any => {
      const folderId = clone.calendar.defaultCalendar
      const folders = calendarService.getCalendars()
      let selectedFolder =
        folderId == null ? null : folders.find((f: any) => isSameDavUrl(f.url, folderId)) //default folder

      return {
        useValue: true,
        onGetValue: (info: any, wrapper: any) => {
          console.log('customFolder onGetValue : ', wrapper, info)
        },
        onSetValue: (value: any, info: any, wrapper: any) => {
          console.log('customContactSelect onSetValue : ', wrapper, info, value)
          console.log('selectedFolder : ', selectedFolder)
        },
        getElement: (info: any, wrapper: any) => {
          const { reactObj } = wrapper
          const { owner } = reactObj.props
          return (
            <div className={styles.customFolderSelector}>
              <FolderSelector
                selectedFolder={selectedFolder}
                folders={folders}
                disabled={false}
                onFolderChange={(folder: any) => {
                  const orgValues = owner.newValues.calendar || owner.defaultValues.calendar
                  owner.onChangeValue('calendar', {
                    ...orgValues,
                    defaultCalendar: toDavPath(folder?.url) || null,
                  })
                  selectedFolder = folder
                }}
                settingType="calendar"
              />
            </div>
          )
        },
      }
    }

    const uiProps: any = {
      defaultCalendar: {
        labelKey: i18Key('settings.fields.defaultCalendar'),
        readOnly: false,
        format: 'custom',
        ...getCustomFolder(),
        vGroup: vGroups[0],
      },
      autoAcceptSharedCalendarNoti: {
        labelKey: i18Key('settings.fields.autoAcceptSharedCalendarNoti'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[1],
      },
    }

    this.vGroupMap.advanced = vGroups

    this.uiGroupMap.advanced = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  applySettings = (): void => {
    const clone = settings.getAll()
    const localCalendar = clone.localSettings?.calendar ?? {}
    const calendarValues = { ...clone.calendar, ...localCalendar }
    this.curValueMap = { ...calendarValues }
    Object.keys(this.uiGroupMap).forEach((key) => {
      this.uiGroupMap[key].setValue(calendarValues, true)
    })
  }

  onPropsChange = (key: string, value: any): void => {
    // console.log(' --- onPropsChange : ', key, value)

    const { owner } = this.props

    // 로컬 전용 설정: sync 대상 calendar 카테고리가 아니라 localSettings.calendar 로 저장
    if (key === 'autoAcceptSharedCalendarNoti') {
      if (owner != null && owner.onChangeValue != null) {
        owner.onChangeValue('localSettings.calendar.autoAcceptSharedCalendarNoti', value)
      }
      return
    }

    const orgValues = { ...owner.defaultValues.calendar, ...owner.newValues.calendar }
    if (key === 'primaryTimezoneLabel') {
      if (value === null || value === '') {
        orgValues[key] = null
      } else {
        orgValues[key] = value
      }
    } else if (key === 'secondaryTimezoneLabel') {
      if (value === null || value === '') {
        orgValues[key] = orgValues.secondaryTimezone
          ? /* i18next-extract-disable-next-line */
            i18n.t('timezone.' + orgValues.secondaryTimezone)
          : i18n.t('settings.accountTabs.none')
      } else {
        orgValues[key] = value
      }
    } else {
      orgValues[key] = value
    }

    if (owner != null && owner.onChangeValue != null) {
      owner.onChangeValue('calendar', { ...orgValues })
    }
  }

  getTabsAttrs = (): any => {
    const { owner, isMobile, parentLabel, idx } = this.props
    const { t } = i18n

    if (this.isUICreated === false) {
      this.createUIGroup()
    }

    let defaultActiveKey: string | null = null
    const { selectedTabs } = owner
    if (selectedTabs != null && selectedTabs.length > 1) {
      defaultActiveKey = selectedTabs[1]
    }

    const items = [
      {
        key: 'general',
        label: (
          <div className={classNames('tabItem', 'general', styles.general)}>
            <div className={classNames(styles.label)}>{t('settings.calendarTabs.general')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'general', styles.general)}>
            {this.uiGroupMap.general.getElement()}
          </div>
        ),
      },
      {
        key: 'view',
        label: (
          <div className={classNames('tabItem', 'view', styles.view)}>
            <div className={classNames(styles.icon)} />
            <div className={classNames(styles.label)}>{t('settings.calendarTabs.view')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'view', styles.view)}>
            {this.uiGroupMap.view.getElement()}
          </div>
        ),
      },
      {
        key: 'timezone',
        label: (
          <div className={classNames('tabItem', 'timezone', styles.timezone)}>
            <div className={classNames(styles.label)}>{t('settings.calendarTabs.timeZone')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'timezone', styles.timezone)}>
            {this.uiGroupMap.timezone.getElement()}
          </div>
        ),
      },
      {
        key: 'workHours',
        label: (
          <div className={classNames('tabItem', 'workHours', styles.workHours)}>
            <div className={classNames(styles.label)}>{t('settings.calendarTabs.workHours')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'workHours', styles.workHours)}>
            <WorkHoursPanel
              onWorkHoursChange={(workHours: any) => {
                this.onPropsChange('workHours', workHours)
              }}
            />
          </div>
        ),
      },
      {
        key: 'advanced',
        label: (
          <div className={classNames('tabItem', 'advanced', styles.advanced)}>
            <div className={classNames(styles.label)}>{t('settings.calendarTabs.advanced')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'advanced', styles.advanced)}>
            {this.uiGroupMap.advanced.getElement()}
            <div className={classNames(styles.filterDesc)}>
              {t('settings.fields.autoAcceptSharedCalendarNotiDesc')}
            </div>
          </div>
        ),
      },
    ]

    const tabsAttrs: any = {
      className: classNames('subTabs'),
      items,
      centered: true,
      tabPosition: 'left',
      tabBarExtraContent: isMobile ? { left: parentLabel } : null,
      // onChange: (activeKey) => {
      // },
      onTabClick: (activeKey: string) => {
        const item = items.find((item) => item.key === activeKey)
        if (item != null) {
          const index = parseInt(idx as string, 10)
          owner.mobileViewObj.setKey(1, activeKey, [parentLabel, item.label], index)
        }
      },
    }

    if (defaultActiveKey != null) {
      tabsAttrs.defaultActiveKey = defaultActiveKey
    }

    return tabsAttrs
  }

  render(): React.ReactNode {
    const tabsAttrs = this.getTabsAttrs()

    return (
      <div className={classNames(styles.calendar)}>
        <OmTabs {...tabsAttrs} />
      </div>
    )
  }
}

export default SettingItem
